import React, { useState } from 'react';

import { BoxContainer, Breadcrumb, Typography } from '../../components';
import { URLS } from '../../utils';
import CrtReportsTable from './components/CrtReportsTable';
import useCrtReports from './hooks/useCrtReports';

const PageContent = () => {
  const breadcrumbItems = [
    { location: URLS.dashboard, name: 'Dashboard' },
    {
      location: URLS.reportCRT,
      name: 'Reporte de CRT Operativas',
      withUserRole: true,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);

  const {
    data,
    isLoading,
    crtReportsFilters,
    crtReportsFilterOptions,
    generateReportPDF,
    generateReportXLXS,
  } = useCrtReports({
    paginationCurrentPage: currentPage,
  });

  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <Breadcrumb items={breadcrumbItems} />
      <Typography theme="h1" as="h1" $marginBottom="2rem">
        Reporte de CRT
      </Typography>
      <CrtReportsTable
        data={data}
        isLoading={isLoading}
        currentPage={currentPage}
        onFilter={crtReportsFilters}
        onPaginationChange={setCurrentPage}
        onGenerateReportPDF={generateReportPDF}
        onGenerateReportXLXS={generateReportXLXS}
        onCrtReportsFilterOptions={crtReportsFilterOptions}
      />
    </BoxContainer>
  );
};

export default PageContent;
